import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';

@Component({
  selector: 'app-dialog-reply-change',
  templateUrl: './dialog-reply-change.component.html',
  styleUrls: ['./dialog-reply-change.component.scss'],
})
export class DialogReplyChangeComponent {
  @Input()
  data!: DialogConfig<NzTreeNode[]>;

  editing: { [name: string]: boolean } = {};

  userTreeNode: NzTreeNode[] = [];

  unitCascaderValue: number[] = [];

  constructor() { }

  get canConfirm() {
    return this.unitCascaderValue.length > 0;
  }

  ngOnInit() {
    this.userTreeNode = this.data.data!;
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.data.onConfirm!(this.unitCascaderValue);
  }
}
